import { useState, useContext, useEffect } from "react";
import { ToastContext, RequestLoader } from "../../../hooks/context";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getRandomIntInclusive } from "../../../helpers";
import { loginUserVerification, resendLoginOTP } from "../../../services/auth";
import useGrantAccessToApp from "../../../hooks/useGrantAccessToApp";
import { pathConstants } from "../../../routes/pathContants";
import { useGetProfileDetails } from "../../../hooks/api/queries/useSettings";

const LoginVerificationLogic = () => {
  const [isVerifing, setIsVerifing] = useState(false);
  const [otp, setOtp] = useState("");
  const triggerToast = useContext(ToastContext);
  const navigate = useNavigate();
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const params = useSearchParams()[0];
  const email = params.get("email");
  const sent_to = params.get("sent_to");
  const sessionId = params.get("session_id");
  const phone_number = params.get("phone_number");
  const [countDown, setCountDown] = useState(120);
  const [sentTo, setSendTo] = useState(sent_to);
  const { setAuthTokensAndGrantAccessToApp } = useGrantAccessToApp({
    message: "Login Successful",
  });
  const [tokens, setTokens] = useState({
    refreshToken: null,
    accessToken: null,
    wsCredentials: null,
  });
  const { isLoading, data: profileDetails } = useGetProfileDetails({
    isProfileEnabled: tokens?.accessToken ? true : false,
    accessToken: tokens?.accessToken,
  });

  useEffect(() => {
    if (!sessionId && !email) return navigate(pathConstants.LOGIN);
  }, []);

  useEffect(() => {
    if (!isLoading && tokens?.refreshToken) getUserProfileDetails();
  }, [isLoading, tokens]);

  useEffect(() => {
    let interval = setInterval(() => {
      if (countDown <= 0) return clearInterval(interval);
      setCountDown((prevState) => prevState - 1);
    }, 1000);

    return () => clearInterval(interval);
  });

  const handleOTPInputs = (value) => {
    setOtp(value);
    if (value?.length !== 4) return;
    setIsVerifing(true);
    setRequestLoaderProgress(getRandomIntInclusive(3, 30));
    loginUserVerification({ otp: value, sessionId: sessionId })
      .then((response) => {
        const { access, refresh, websocket } = response?.data?.data;
        setTokens({
          refreshToken: refresh,
          accessToken: access,
          wsCredentials: websocket
            ? { token: websocket.token, socketUrl: websocket.socket_url }
            : null,
        });
      })
      .finally(() => {
        setIsVerifing(false);
        setRequestLoaderProgress(100);
      });
  };

  const getUserProfileDetails = () => {
    if (!profileDetails.email_verified) {
      triggerToast("Please verify your email", "warning");
      return navigate(
        `${pathConstants.EMAIL_VERIFICATION}?email=${email}&token=${tokens?.accessToken}`,
      );
    }
    setAuthTokensAndGrantAccessToApp({
      refreshToken: tokens?.refreshToken,
      accessToken: tokens?.accessToken,
      profileDetails: profileDetails,
      wsCredentials: tokens?.wsCredentials,
    });
  };

  const handleResendOtp = (type = "email") => {
    setRequestLoaderProgress(getRandomIntInclusive(3, 30));
    resendLoginOTP({ sessionId, type })
      .then((res) => {
        setCountDown(120);
        setSendTo(type === "email" ? res?.data?.data?.sent_to : phone_number);
        triggerToast("OTP sent successfully", "success");
      })
      .catch(() => {})
      .finally(() => {
        setRequestLoaderProgress(100);
      });
  };

  return {
    isVerifing,
    otp,
    email,
    sent_to,
    countDown,
    sentTo,
    phone_number,
    handleOTPInputs,
    handleResendOtp,
  };
};

export default LoginVerificationLogic;
